import styled from 'styled-components';

export const SliderWrapper = styled.div`
  display: none;

  @media screen and (max-width: 900px) {
    display: block;
    width: 114%;
    min-height: 150px;
    position: relative;
    overflow-x: hidden;
    overflow-y: visible;
    max-width: 350px;
    margin: 0 auto;
  }
`;

export const SliderList = styled.ul`
  display: flex;
  width: 100%;
  height: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  max-width: 350px;
`;

export const ItemSlide = styled.li`
  flex-shrink: 0;
  height: 100%;
`;

export const CommentItem = styled.div`
  flex: 1;
  margin: 10px;
  padding: 16px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 375px) {
    margin: 10px 6px;
    min-height: 200px;
  }

  @media screen and (max-width: 320px) {
    min-height: 240px;
  }
`;
